<template>
  <el-dialog :title="detailTitle" :visible.sync="detailDialogVisible" width="600px" center>
    <div class="detail">
      <div class='baseInfo'>
        <div class='baseInfoTitle'>
          <div class='line' />
          <span>审核信息</span>
        </div>
        <steps :step-data='stepData' :step-state='stepState' />
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { getHistoryReview} from "@/service/vehiclelog";
import steps from '@/components/steps';

export default {
  components: {steps},
  data(){
    return{
      detailDialogVisible: false,
      detailData: {},
      detailTitle: '',
      stepData: [],
    }
  },
  computed: {
    stepState() {
      return function (state) {
        switch (state) {
          case '':
            return 'wait';
          case 'success':
            return 'success';
          case 'failure':
            return 'error';
        }
      };
    },
  },
  methods:{
    dialogOpen(id){
      this.detailDialogVisible = true;
      this.detailTitle = '历史审核记录'
      this.getHistoryReview(id)
    },
    async getHistoryReview(id) {
      let res = await getHistoryReview(id)
      if (res.status !== 0) return this.$message.error(res.message);
      // 审核信息
      this.stepData = [];
      if (res.data && res.data.length > 0) {
        res.data.forEach((item) => {
          let status = '',
            temp = {
              title: '',
              time: '',
              state: '',
              remark: '',
            },
            text = '取消审核';
          if (item.status == 1) {
            text = '发起';
          }
          if (item.status == 0) {
            text = '重新发起 ';
          }
          if (item.status == 4) {
            text = '取消审核';
          }
          if (item.status == 3) {
            status = 'failure', text = '拒绝';
            temp = {
              'title': (item.deptName || '') + ' ' + (item.auditorName || '') + ' ' + text,
              'time': (item.createTime || ''),
              'state': status,
              'remark': (item.opinion || ''),
            };
          } else if (item.status == 2) {
            status = 'success', text = '同意';
            temp = {
              'title': (item.deptName || '') + ' ' + (item.auditorName || '') + ' ' + text,
              'time': (item.createTime || ''),
              'state': status,
              'remark': (item.opinion || ''),
            };
          } else {
            temp = {
              'title': (item.auditorName || '') + ' ' + text,
              'time': (item.createTime || ''),
              'state': status,
              'remark': (item.opinion || ''),
            };
          }
          this.stepData.push(temp);
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
